import { ColumnDef, createColumnHelper } from "@tanstack/react-table";
import moment from "moment";
import { cx } from "shared/utils";
import { formatToCurrency } from "utils/currency";
import { BankStatementIncomeSource } from "../../../types";

type transactionColumnType =
  BankStatementIncomeSource["uploaded_docs"][number]["transactions"][number];

const columnHelper = createColumnHelper<transactionColumnType>();

export const transactionColumns: ColumnDef<transactionColumnType, any>[] = [
  columnHelper.accessor("description", {
    header: "Transaction description",
    size: 450,
    cell: ({ getValue }) => {
      const description = getValue();
      return (
        <p className="text-content-1000 text-sm truncate">{description}</p>
      );
    }
  }),
  columnHelper.accessor("txn_date", {
    header: "Date",
    size: 100,
    cell: ({ getValue }) => {
      const date = getValue();
      return (
        <p className="text-content-1000 text-sm">
          {moment(date).format("MMM DD, YYYY")}
        </p>
      );
    }
  }),
  columnHelper.accessor("amount", {
    header: "Amount",
    size: 100,
    cell: (p) => {
      const amount = p.getValue();
      const originalAmount = p.row.original.original_amount;
      return (
        <p
          className={cx(
            "text-content-1000 text-sm font-medium",
            originalAmount[0] === "-" ? "text-danger-500" : "text-success-700"
          )}
        >
          {formatToCurrency(amount)}
        </p>
      );
    }
  })
];
